/** @jsx jsx */
import React from 'react';

import { Interpolation, jsx, Theme } from '@emotion/react';
import styled from '@emotion/styled';

import { ModuleComponents } from '../../components/ModuleComponents';

interface ContainerPropsStyled {
    size?: string;
    noPadding?: boolean;
}

interface ContainerProps extends ContainerPropsStyled {
    css?: Interpolation<Theme>;
    components?: any;
}

export const Container: React.FC<ContainerProps> = ({
    children,
    components,
    size,
    ...props
}) => {
    return (
        <StyledContainer size={size} {...props}>
            {components && <ModuleComponents components={components} />}
            {children}
        </StyledContainer>
    );
};

const StyledContainer = styled.div<ContainerPropsStyled>`
    width: 100%;

    margin: 0 auto;

    ${(props) => props.size && `max-width: ${props.size};`}
    ${(props) => (props.noPadding ? `padding: 0;` : `padding: 0 15px;`)}
`;
